import { fromJS, is } from 'immutable';
import ACTIONS, { FETCH_STATUS } from '../constants';
import { jwtDecode } from 'jwt-decode';

const initialState = fromJS({
  user: {},
  userId: '',
  accessToken: '',
  refreshToken: '',
  userPermissions: [],
  userRole: '',
  loading: false,
  error: '',
  logo: '',
});

export default function authReducer(state = initialState, action) {
  switch (action.type) {

    case ACTIONS.LOGIN.PENDING: {
      return state.set('loading', true)
                  .set('error', {})
                  .set('mfaError', {});
    }

    case ACTIONS.LOGIN.SUCCESS: {
      if(action.data.isMfaRequired){
        return state.set('loading', false)
        .set('error', {})
        .set('mfaError', {})
        .set('isMfaRequired', true);
      }
      else if(action.data.isPasswordResetRequired){
        return state.set('loading', false)
        .set('error', {})
        .set('mfaError', {})
        .set('resetPasswordResponse', null)
        .set('isPasswordResetRequired', true)
        .set('passwordResetToken', action.data.token);
      }
      else if(action.data.isMfaSetupRequired){
        return state.set('loading', false)
        .set('error', {})
        .set('mfaError', {})
        .set('mfaSetupToken', action.data.token)
        .set('isMfaSetupRequired', true);
      }
      else{
        const decoded = jwtDecode(action.data.accessToken);
        return state.set('loading', false)
          .set('error', {})
          .set('mfaError', {})
          .set('userId', decoded.id)
          .set('permission', decoded.permission)
          .set('accessToken', action.data.accessToken)
          .set('refreshToken', action.data.refreshToken)
          .set('user', action.data.user)
          .set('isMfaRequired', false)
          .set('isMfaSetupRequired', false)
          .set('mfaSetupToken', null)
          .set('isPasswordResetRequired', false)
          .set('passwordResetToken', null)
          .set('resetPasswordResponse', null);
      }
      
    }

    case ACTIONS.LOGIN.ERROR: {
      var error = action.isMfa ? 'mfaError' :'error';
      var cleanError = !action.isMfa ? 'mfaError' :'error';
      return state.set('loading', false)
                  .set(error, action.error)
                  .set(cleanError, {});
    }

    case ACTIONS.FETCH_LOGO.PENDING: {
      // return state.set('loading', true);
    }

    case ACTIONS.FETCH_LOGO.SUCCESS: {
      return state.set('logo', action.data);
    }
    
    case ACTIONS.FETCH_LOGO.ERROR: {
      return state.set('error', '');
    }

    case ACTIONS.RESET_PASSWORD.PENDING: {
      return state.set('loading', true)
                  .set('error', {})
                  .set('mfaError', {});
    }
    case ACTIONS.RESET_PASSWORD.SUCCESS: {
      return state.set('loading', false)
                  .set('error', {})
                  .set('mfaError', {})
                  .set('isMfaRequired', false)
                  .set('isMfaSetupRequired', false)
                  .set('isPasswordResetRequired', false)
                  .set('passwordResetToken', null)
                  .set('resetPasswordResponse', {isSuccess: true, message: action.data.message});
    }
    case ACTIONS.RESET_PASSWORD.ERROR: {
      return state.set('loading', false)
                  .set('error', {})
                  .set('mfaError', {})
                  .set('resetPasswordResponse', {isSuccess: false, message: action.error.message});
    }
    case ACTIONS.RESET_LOGIN_ACTIONS.SUCCESS: {
      return state.set('loading', false)
                  .set('error', {})
                  .set('mfaError', {})
                  .set('isMfaRequired', false)
                  .set('isMfaSetupRequired', false)
                  .set('mfaSetupToken', null)
                  .set('isPasswordResetRequired', false)
                  .set('passwordResetToken', null);
    }
    default: {
      return state;
    }
  }
}